export enum FunnelCompleteStep {
  Phone = 'phone',
  Cv = 'cv',
  PotentialJobs = 'potentialJobs',
  Finish = 'finish',
  /** jobBoard - Introduced as part of DirectLoginToJobBoardPostRegistration FF */
  JobBoard = 'jobBoard',
}
